import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Instagram from '../icons/Instagram.svg';
import Medium from '../icons/Medium.svg';


const About = () => (
  <div>
    <div className="about">
            <div className="wrapper">
            <div className="about__info">
                <div className="about__info-left">
                    <p>Workplaces is a series of documentary profiles showcasing the cultures and values of technology companies in the Underdog.io network.</p>

                    <p>Our goal with this product is to encourage introspection about work and give people a deeper view into how companies truly practice their cultures.</p>

                    <p>It's not easy to find a team with shared values, working on the type of problems that you like to solve. We hope that Workplaces will help readers learn more about what they want out of a company, and help companies reflect upon and design their own rituals and cultural systems.</p>
                </div>
                <div className="about__info-right">


                    <a href="https://medium.com/underdogjobs/workplaces-afc280c8ec8d" target="_blank">
                    <div className="about__cta">
                        <div className="about__cta-icon">
                        <Medium/>
                        </div>
                        <div className="about__cta-text">
                            <div className="cta-title"> Read more about Workplaces and our strategic vision </div>
                        </div>
                    </div>
                    </a>

                    <a href="https://www.instagram.com/underdogio/" target="_blank">
                    <div className="about__cta">
                        <div className="about__cta-icon">
                        <Instagram/>
                        </div>
                        <div className="about__cta-text">
                            <div className="cta-title">  Follow Workplaces on Instagram </div>
                        </div>
                    </div>
                    </a>

                </div>
            </div>
            </div>

    </div>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.jsx